import React, { useState, Fragment, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import { getAppEnabled } from '../../../../Resources/Organization/Apps/AppsData.js'
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog'
import { toggleEnabledWithEntity } from '../Redux/Actions.js'
import { RESPONSIBID } from '../AppsData.js'
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel'

const ResponsibidButton = () => {
  const appEnabled = useSelector(getAppEnabled(RESPONSIBID))
  const [dialogOpen, setDialogOpen] = useState(false)
  const dispatch = useDispatch()

  const onSwitchChange = (event, checked) => {
    if (checked) {
      setDialogOpen(true)
    } else {
      onToggleAppEnabled()
    }
  }
  const onToggleAppEnabled = () => dispatch(toggleEnabledWithEntity(RESPONSIBID))

  const onCloseDialog = useCallback(() => setDialogOpen(false), [])

  const onDialogConfirmationClick = useCallback(() => {
    setDialogOpen(false)
    onToggleAppEnabled()
    window.open('https://bids.responsibid.com/SignUp?promo=hcp', '_blank')
  }, [])

  return (
    <Fragment>
      <FormControlLabel control={<Switch checked={appEnabled} onChange={onSwitchChange} />} label={appEnabled ? 'Active' : 'Disabled'} />
      <br/>
      Enabling this toggle will share your contact information with the partner
      <ConfirmationDialog
        open={dialogOpen}
        title='Connect to ResponsiBid'
        onClose={onCloseDialog}
        leftButton={<Button onClick={onCloseDialog}>Cancel</Button>}
        rightButton={
          <Button color='primary' onClick={onDialogConfirmationClick}>
            Connect account
          </Button>
        }>
        <Typography variant='body1'>
          You’re almost done. Sign up or login to your ResponsiBid account now to enable the integration.
        </Typography>
      </ConfirmationDialog>
    </Fragment>
  )
}

export default ResponsibidButton
